import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
import ZIcon from '~/components/zeal/ZIcon/ZIcon.vue'

// Generate unique IDs (client-side only to avoid SSR hydration mismatch)

const __default__ = {
  inheritAttrs: false
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'UIInput',
  props: {
  label: {
    type: String,
    default: ''
  },
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  errorMessage: {
    type: String,
    default: ''
  },
  helperText: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const uniqueId = ref('')
const inputId = computed(() => (uniqueId.value ? `input-${uniqueId.value}` : undefined))
const descriptionId = computed(() =>
  uniqueId.value ? `input-description-${uniqueId.value}` : undefined
)

onMounted(() => {
  uniqueId.value = Math.random().toString(36).substring(2, 11)
})





const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.value)
}

return { __sfc: true,uniqueId, inputId, descriptionId, emit, onInput, ZIcon }
}

})